import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"


const HowWeCollect = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{fontStyle:"bold"}}>
             3. How We Collect the Information
        </Typography>
        <Typography sx={{ fontSize: '1.1rem' }}>
            We collect data through the following means
            <List>
                <ListItem>
                    <ListItemText>
                        •  Direct input by users during profile setup or task execution
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
              •  Automated collection during location tracking and check-ins
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                          •  Admin-uploaded information (e.g., assigning customers or leads)
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                 •  System logs and app activity generated automatically
                    </ListItemText>
                </ListItem>
                  <ListItem>
                    <ListItemText>
                 •   Through mobile app sensors with user consent
                    </ListItemText>
                </ListItem>
            </List>
            No cookies or third-party trackers are used in the mobile application.
        </Typography>
         <Divider sx={{ my: 2 }} />
    </>
  )
}

export default HowWeCollect